<template lang="pug">
div
  div(v-if="!isFetching")
    div(v-if="eInvoice" :class="inline ? 'd-flex align-center' : ''")
      v-alert.round-xl.mb-0(v-bind="alertProps" text dense)
        div.d-flex.align-center
          .text-sm.font-semibold.neutral700--text e-Invoice status:
          .text-sm.ml-2.neutral700--text {{ statusText }}
          v-spacer
          template(v-if="eInvoice.type === 'single' && eInvoice.status_text === 'Valid'")
            y-button.ml-2(label="copy link" size="xxs" height="24" background-color="var(--v-neutral100)" unset-min-width outlined button-class="px-1" @click="copyLink")
          template(v-if="eInvoice.type === 'consolidated' && !isSubmitted")
            yz-tooltip(:text="consolidatedTooltipText" max-width="280")
              y-button.ml-2(size="xs" height="24" background-color="var(--v-neutral100)" prepend-icon="$yzi-link-broken-02" icon-size="14" unset-min-width outlined button-class="px-1" @click="onIndividualResubmit")
      y-button(v-if="isInvalidOrCancelled" label="Resubmit e-Invoice" size="sm" color="primary" :block="!inline" :class="inline ? 'ml-2' : 'mt-3'" @click="showEInvoiceDialog = true")

    y-button(v-else label="Submit e-Invoice" size="sm" color="primary" :block="!inline" @click="showEInvoiceDialog = true")
  
  .dialogs
    e-invoice-dialog(v-if="showEInvoiceDialog" :open.sync="showEInvoiceDialog" :invoice="invoice" :einvoice.sync="eInvoice" :transactions="transactions")

    individual-resubmission-dialog(v-if="showIndividualResubmitDialog" :open.sync="showIndividualResubmitDialog" :invoice="invoice" :einvoice-id="eInvoice.id" :transactions="transactions" @confirm="onCreateCreditNote")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EInvoiceDialog from '@/components/clinic/checkout/EInvoiceDialog.vue'
import IndividualResubmissionDialog from '@/components/clinic/checkout/IndividualResubmissionDialog.vue'

export default {
  components: { EInvoiceDialog, IndividualResubmissionDialog },
  props: {
    invoice: {
      required: true,
      type: Object,
      default: (() => {})
    },
    inline: {
      type: Boolean,
      default: false
    },
    transactions: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      isFetching: false,
      showEInvoiceDialog: false,
      showIndividualResubmitDialog: false,
      eInvoice: null
    }
  },
  computed: {
    ...mapGetters({
      isHq: 'hq/getIsHq'
    }),
    isInvalidOrCancelled () {
      return ['Invalid', 'Cancelled'].includes(this.eInvoice?.status_text)
    },
    isSubmitted () {
      return this.eInvoice?.status_text === 'Submitted'
    },
    alertProps () {
      const status = this.eInvoice?.status_text
      if (status === 'Valid') return { color: 'success' }
      if (['Invalid', 'Cancelled'].includes(status)) return { type: 'error' }
      return { color: 'info' }
    },
    statusText () {
      const status = this.eInvoice?.status_text
      if (status === 'Valid') return 'Validated'
      if (['Invalid', 'Cancelled'].includes(status)) return status
      return 'Pending Verification'
    },
    consolidatedTooltipText () {
      if (!this.eInvoice) return ''
      const status = this.eInvoice.status_text
      if (status === 'Valid') return 'Consolidated e-Invoice has been validated. Click if you wish to resubmit e-Invoice individually.'
      if (status === 'Invalid') return 'Consolidated e-Invoice has been submitted and is invalid. Click if you wish to resubmit e-Invoice individually.'
      return 'Consolidated e-Invoice has been submitted and is pending verification. Click if you wish to resubmit e-Invoice individually.'
    }
  },
  mounted () {
    this.fetchEInvoice()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchEInvoice () {
      if (!this.invoice?.pid) return
      this.isFetching = true
      this.$axios.get(`/invoices/${this.invoice.pid}/einvoice`)
        .then(resp => {
          this.eInvoice = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    onIndividualResubmit () {
      this.showIndividualResubmitDialog = true
    },
    onCreateCreditNote () {
      this.showIndividualResubmitDialog = false
      this.fetchEInvoice()
    },
    copyLink () {
      navigator.clipboard.writeText(process.env.VUE_APP_E_INVOICE_URL + `/${this.eInvoice.uuid}/share/${this.eInvoice.long_id}`)
        .then(() => {
          this.showMessage(['success', 'Link copied'])
        })
        .catch(() => {
          this.showMessage(['error', 'Failed to copy link'])
        })
    }
  }
}
</script>

<style>

</style>